module.exports = __webpack_public_path__ + "static/media/toy-logo.5a1a6a9f.png";